import { PropsWithChildren } from 'react';
import { TableTd } from '@mantine/core';
import classes from './TouringCardTableRowLabel.module.css';

export const TouringCardTableRowLabel: React.FC<PropsWithChildren> = ({
  children,
}) => {
  return (
    <TableTd w={140} className={classes.label}>
      {children}
    </TableTd>
  );
};
